import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, AlertTriangle, ArrowLeft, RefreshCw } from 'lucide-react';

import VistoriaRegiaoMain from './VistoriaRegiaoMain';
import { laudoApi } from '../../services/laudoApi';

/**
 * ============================================================
 * COMPONENTE: VistoriaStandalone
 * ------------------------------------------------------------
 * Rota: /vistorias/:id
 * Abre uma vistoria avulsa (fora do fluxo de laudo).
 * VERSÃO: 1.0.0
 * ============================================================
 */

export default function VistoriaStandalone() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [laudo, setLaudo] = useState(null);
  const [infoLaudo, setInfoLaudo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);

  const carregar = async () => {
    if (!id) {
      setErro('ID da vistoria ausente na URL.');
      setLoading(false);
      return;
    }

    setLoading(true);
    setErro(null);

    try {
      const dados = await laudoApi.carregarVistoria(id);
      const payload = dados?.data || dados;

      setLaudo(payload?.laudo || payload || {});
      setInfoLaudo({
        numero: payload?.reportNumber || payload?.report_id || `MH-${id}`,
        engenheiro: payload?.perito || payload?.engenheiro || 'PERITO RESPONSÁVEL',
        titulo: payload?.titulo || `Vistoria ${id}`,
        endereco: payload?.endereco || null,
      });
    } catch (err) {
      setErro(err.message || 'Falha ao carregar vistoria.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { carregar(); }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center gap-4">
        <Loader2 size={48} className="text-amber-400 animate-spin" />
        <p className="text-[10px] text-slate-500 tracking-[0.5em] font-black italic uppercase">
          CARREGANDO VISTORIA
        </p>
      </div>
    );
  }

  if (erro) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center p-8">
        <div className="max-w-lg w-full bg-red-950/50 border-2 border-red-500/30 rounded-[3rem] p-10 text-center space-y-6">
          <AlertTriangle size={48} className="text-red-400 mx-auto" />
          <p className="text-red-200 text-[12px] tracking-widest leading-relaxed normal-case">
            {erro}
          </p>
          <div className="flex gap-3 justify-center">
            <button
              type="button"
              onClick={() => navigate('/vistorias')}
              className="px-6 py-3 rounded-2xl bg-white/5 border border-white/10 text-white text-[10px] tracking-widest hover:bg-white/10 transition-all flex items-center gap-2"
            >
              <ArrowLeft size={14} /> VOLTAR
            </button>
            <button
              type="button"
              onClick={carregar}
              className="px-6 py-3 rounded-2xl bg-amber-400 text-slate-950 text-[10px] tracking-widest hover:bg-white transition-all flex items-center gap-2"
            >
              <RefreshCw size={14} /> TENTAR NOVAMENTE
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <VistoriaRegiaoMain
      infoLaudo={infoLaudo}
      peritoAtivo={infoLaudo.engenheiro}
      laudoInicial={laudo}
      onProtocolo={({ hashDigital }) => {
        console.info('[Vistoria Standalone] Protocolo selado', { hashDigital });
        navigate('/vistorias');
      }}
    />
  );
}